import React, { useState } from 'react'

import {
  Swiper,
  SwiperSlide
} from 'swiper/react'

import {
  Navigation,
  EffectFade,
  Controller,
  EffectCreative
} from 'swiper'

import SyncedSliderItem from './Slide'
import SyncedImage from './Image'
import Icon from '@/atoms/Icon'

import {
  StyledSyncedCarousel,
  StyledSyncedSlider,
  StyledSyncedSliderNavigation,
  StyledSyncedSliderNavigationButton,
  StyledSyncedImages,
  StyledSyncedImagesWrapper,
} from './styles'

const SyncedSlider = ({
  slider,
  images
}) => {
  const [firstSwiper, setFirstSwiper] = useState(null)
  const [secondSwiper, setSecondSwiper] = useState(null)

  const updateSlideAccessibility = (swiper) => {
    if (!swiper?.slides) return

    swiper.slides.forEach((slide, index) => {
      const isActive = index === swiper.activeIndex

      slide.setAttribute('aria-hidden', !isActive)
      slide.setAttribute('tabindex', isActive ? '0' : '-1')

      const focusableElements = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
      focusableElements.forEach(element => {
        element.setAttribute('tabindex', isActive ? '0' : '-1')
      })
    })
  }

  const handleSlideChange = (swiper) => {
    updateSlideAccessibility(swiper)
  }

  const handleSwiperInit = (swiper, setSwiper) => {
    setSwiper(swiper)
    setTimeout(() => updateSlideAccessibility(swiper), 0)
  }

  return (
    <StyledSyncedCarousel>
      {
        slider &&
        !!slider.length &&
        <StyledSyncedSlider>
          <Swiper
            modules={[Navigation, EffectFade, Controller]}
            onSwiper={(swiper) => handleSwiperInit(swiper, setFirstSwiper)}
            speed={1000}
            controller={{ control: secondSwiper }}
            navigation={{
              nextEl: '.synced-slider-button-next',
              prevEl: '.synced-slider-button-prev',
            }}
            slidesPerView={1}
            effect='fade'
            fadeEffect={ { crossFade: true }}
            onSlideChange={handleSlideChange}
            role="region"
            aria-label="Slider di contenuti"
            aria-roledescription="slider"
          >
            {
              slider.map((item, index) => (
                <SwiperSlide
                  key={`slide_${item.id}`}
                  role="group"
                  aria-roledescription="slide"
                  aria-label={`${index + 1} di ${slider.length}: ${item.title}`}
                >
                  <SyncedSliderItem {...item} />
                </SwiperSlide>
              ))
            }

            <StyledSyncedSliderNavigation>
              <StyledSyncedSliderNavigationButton
                aria-label='slide precedente'
                className='synced-slider-button-prev'
              >
                <Icon name="chevron-left" />
              </StyledSyncedSliderNavigationButton>

              <StyledSyncedSliderNavigationButton
                aria-label='slide successiva'
                className='synced-slider-button-next'
              >
                <Icon name="chevron-right" />
              </StyledSyncedSliderNavigationButton>
            </StyledSyncedSliderNavigation>
          </Swiper>
        </StyledSyncedSlider>
      }

      {
        images &&
        !!images.length &&
        <StyledSyncedImages>
          <StyledSyncedImagesWrapper>
            <Swiper
              modules={[Controller, EffectCreative]}
              onSwiper={(swiper) => handleSwiperInit(swiper, setSecondSwiper)}
              controller={{ control: firstSwiper }}
              slidesPerView={1}
              effect={'creative'}
              speed={1000}
              onSlideChange={handleSlideChange}
              role="region"
              aria-label="Contenuti correlati"
              aria-roledescription="slider"
              creativeEffect={{
                prev: {
                  origin: 'right center',
                  translate: ['100%', 0, -400],
                  rotate: [0, 180, 0],
                  opacity: 0,
                  scale: 0.5,
                },
                next: {
                  origin: 'right center',
                  scale: 0.85,
                  translate: ['10%', 0, -100],
                },
              }}
            >
              {
                images.map((item, index) => (
                  <SwiperSlide
                    key={`image_${item.slideID}`}
                    role="group"
                    aria-roledescription="slide"
                    aria-label={`${index + 1} di ${images.length}: Immagine`}
                  >
                    <SyncedImage {...item} />
                  </SwiperSlide>
                ))
              }
            </Swiper>
          </StyledSyncedImagesWrapper>
        </StyledSyncedImages>
      }

    </StyledSyncedCarousel>
  )
}

export default SyncedSlider
